<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- contenct tab -->
    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <!-- badge -->
          <v-row class="align-center">
            <div class="d-flex align-center ml-4">
              <span class="text-unread status-box">Belum dibaca</span>
              <v-badge
                v-if="total_unread"
                :content="total_unread"
                color="red"
                class="total-unread"
                inline
              ></v-badge>
            </div>
          </v-row>

          <!-- Table -->
          <v-row>
            <v-col>
              <v-card flat outlined class="mb-3">
                <v-card-text class="py-2 px-4">
                  <div
                    class="d-flex align-center justify-space-between flex-wrap"
                  >
                    <!-- Info -->
                    <div class="d-flex align-center">
                      <v-icon
                        color="primary"
                        class="mr-2"
                        v-if="selected.length"
                      >
                        mdi-checkbox-marked-circle-outline
                      </v-icon>

                      <span class="text-body-2">
                        <template v-if="selected.length">
                          <strong>{{ selected.length }}</strong>
                          budget dipilih
                        </template>

                        <template v-else>
                          Pilih satu atau beberapa budget untuk melakukan aksi.
                        </template>
                      </span>
                    </div>

                    <!-- Action -->
                    <div class="d-flex align-center" style="gap: 8px">
                      <v-btn
                        color="success"
                        depressed
                        :disabled="selected.length === 0"
                        @click="openApprovalDialogBulk('approve')"
                      >
                        <v-icon left>mdi-check-bold</v-icon>
                        Approve
                      </v-btn>

                      <v-btn
                        color="error"
                        outlined
                        :disabled="selected.length === 0"
                        @click="openApprovalDialogBulk('reject')"
                      >
                        <v-icon left>mdi-close-thick</v-icon>
                        Reject
                      </v-btn>

                      <v-btn
                        color="warning"
                        outlined
                        :disabled="selected.length === 0"
                        @click="openApprovalDialogBulk('need to analysis')"
                      >
                        <v-icon left>mdi-backup-restore</v-icon>
                        Need Analysis
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-data-table
                v-model="selected"
                show-select
                item-key="budget_id"
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="approvalsList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :loading="isLoading"
                :server-items-length="totalApprovals"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:[`item.transaction_number`]="{ item }">
                  <span
                    @click="openDialogDetail(item)"
                    class="px-2 py-1 rounded text-caption d-inline-flex align-center"
                    :style="{
                      backgroundColor: item.is_unread ? '#E8F5E9' : '#EEEEEE',
                      color: item.is_unread ? '#2E7D32' : '#757575',
                      cursor: 'pointer',
                    }"
                  >
                    {{ item.transaction_number }}

                    <span
                      v-if="item.is_unread"
                      style="
                        width: 6px;
                        height: 6px;
                        background: #4caf50;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    />
                  </span>
                </template>

                <template v-slot:[`item.worksheet_budget_name`]="{ item }">
                  {{ item.worksheet_budget_name }}
                </template>

                <template v-slot:[`item.departement_name`]="{ item }">
                  {{ item.departement_name }}
                </template>

                <template v-slot:[`item.dc_code`]="{ item }">
                  {{ item.dc_code }}
                </template>

                <template v-slot:[`item.corporate_name`]="{ item }">
                  {{ item.corporate_name }}
                </template>

                <template v-slot:[`item.action_history_approval`]="{ item }">
                  <v-tooltip bottom v-if="item.action_history_approval === 't'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openApprovalHistory(item.budget_id)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>

                    Tampilkan
                  </v-tooltip>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                  <v-chip
                    :color="getStatusColor(item.last_status)"
                    x-small
                    outlined
                  >
                    {{ item.last_status }}
                  </v-chip>
                </template>

                <template v-slot:[`item.id`]="{ item }">
                  <div style="font-size: 12px">
                    {{ item.created_by_name }}
                  </div>

                  <div style="font-size: 12px">
                    {{ item.mst_division_name }}
                  </div>

                  <div style="font-size: 12px">
                    {{ item.created_on }}
                  </div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="openApprovalDialog('approve', item)"
                      >
                        <v-icon color="success"> mdi-check </v-icon>
                      </v-btn>
                    </template>

                    Approve
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="openApprovalDialog('reject', item)"
                      >
                        <v-icon> mdi-close </v-icon>
                      </v-btn>
                    </template>

                    Reject
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openApprovalDialog('need to analysis', item)"
                      >
                        <v-icon color="orange"> mdi-backup-restore </v-icon>
                      </v-btn>
                    </template>

                    Need To Analysis
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- content tab 2-->
        <v-tab-item> </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!--  Dialog -->
    <v-dialog v-model="isDialogOpen" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-textarea
              v-model="approvalFormData.comments"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  Dialog Bulk -->
    <v-dialog v-model="isDialogOpenBulk" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitleBulk }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidBulk">
            <v-textarea
              v-model="approvalFormDataBulk.comments"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenBulk = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidBulk"
            @click="submitBulk"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Riwayat Persetujuan -->
    <v-dialog v-model="isDialogOpenApprovalHistory" max-width="700px">
      <v-card>
        <v-card-title class="headline">Riwayat Persetujuan</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersApproval"
          :items="approvalHistoryList"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- detail -->
    <v-dialog v-model="isDialogDetail">
      <v-card class="rounded-0">
        <!-- HEADER -->
        <div class="dialog-header">
          <!-- CLOSE -->
          <v-btn
            icon
            variant="text"
            color="grey-darken-1"
            class="close-btn"
            @click="isDialogDetail = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- TITLE -->
          <div class="px-6 pt-5 pb-3 d-flex justify-space-between align-start">
            <div>
              <div class="text-subtitle-1 font-weight-bold mb-2">
                {{ selectedItem?.transaction_number }}
              </div>

              <v-simple-table dense class="elevation-1">
                <tbody>
                  <tr>
                    <td style="white-space: nowrap">Kertas Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.worksheet_budget_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Account</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.account || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Bagian</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.part || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Departement</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.departement_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Lokasi Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.dc_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Perusahaan</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.corporate_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Tahun</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.fiscal_year || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Kenaikan Harga</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.kenaikan_harga }}%</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>

          <!-- ACTION BAR -->
          <div
            class="px-6 pb-4 d-flex align-center justify-space-between flex-wrap ga-4"
          >
            <div class="d-flex align-center ga-3 flex-wrap">
              <v-btn-toggle
                v-model="showMode"
                mandatory
                color="primary"
                density="comfortable"
                divided
              >
                <v-btn value="qty">
                  <v-icon start size="18">mdi-counter</v-icon>
                  Qty
                </v-btn>

                <v-btn value="values">
                  <v-icon start size="18">mdi-cash</v-icon>
                  Value
                </v-btn>

                <v-btn value="all">
                  <v-icon start size="18">mdi-view-grid</v-icon>
                  Semua
                </v-btn>
              </v-btn-toggle>

              <v-text-field
                v-model="searchDetail"
                placeholder="Cari item..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                density="compact"
                variant="outlined"
                clearable
                class="mx-3"
                style="min-width: 280px; max-width: 350px"
              />
            </div>
          </div>

          <v-divider />
        </div>

        <v-data-table
          class="budget-table"
          density="compact"
          :headers="tableHeadersDetailFiltered"
          :items="filteredListDetail"
          :loading="isLoading"
          item-key="item_id"
          :items-per-page="10"
        >
          <template #body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="index"
                :class="{
                  'new-item-row': Number(item.is_new) === 1,
                }"
              >
                <!-- REALIZATION -->
                <td class="text-center sticky-realization">
                  <v-btn
                    v-if="Number(item.is_new) != 1"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogRealizationByWorksheetId(item)"
                  >
                    <v-icon size="16"> mdi-file-eye </v-icon>
                  </v-btn>
                </td>

                <!-- ITEM -->
                <td>
                  {{ item.item_name }}
                </td>

                <td>
                  {{ item.material_name }}
                </td>

                <!-- ITEM -->
                <td>
                  {{ item.spesification }}
                </td>

                <!-- UOM -->
                <td>
                  {{ item.uom_name }}
                </td>

                <td>
                  <div class="d-flex align-center">
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      @click="openDialogChat(item)"
                    >
                      <v-icon>mdi-forum-outline</v-icon>
                    </v-btn>
                  </div>
                </td>

                <!-- QTY -->
                <template v-if="isQty">
                  <td
                    v-for="month in months"
                    :key="`qty-${item.item_id}-${month.id}`"
                    class="text-center"
                  >
                    <v-text-field
                      v-model.number="item[`${month.key}_qty`]"
                      :disabled="true"
                      type="number"
                      min="0"
                      step="1"
                      variant="outlined"
                      density="compact"
                      hide-details
                      single-line
                      class="month-input"
                      @input="
                        item[`${month.key}_qty`] = Math.max(
                          0,
                          parseInt(item[`${month.key}_qty`] || 0, 10),
                        )
                      "
                      @change="
                        submitUpdateDetail(
                          'qty',
                          Math.max(
                            0,
                            parseInt(item[`${month.key}_qty`] || 0, 10),
                          ),
                          month.id,
                          item.fiscal_year,
                          item.item_id,
                        )
                      "
                    />
                  </td>
                </template>

                <!-- VALUE -->
                <template v-if="isValues">
                  <td
                    v-for="month in months"
                    :key="`value-${item.item_id}-${month.id}`"
                    class="text-center"
                  >
                    <v-text-field
                      :disabled="true"
                      v-model.number="item[`${month.key}_total_price`]"
                      type="number"
                      min="0"
                      step="1"
                      variant="outlined"
                      density="compact"
                      hide-details
                      single-line
                      class="month-input"
                      @input="
                        item[`${month.key}_total_price`] = Math.max(
                          0,
                          parseInt(item[`${month.key}_total_price`] || 0, 10),
                        )
                      "
                      @change="
                        submitUpdateDetail(
                          'total_price',
                          Math.max(
                            0,
                            parseInt(item[`${month.key}_total_price`] || 0, 10),
                          ),
                          month.id,
                          item.fiscal_year,
                          item.item_id,
                        )
                      "
                    />
                  </td>
                </template>

                <td
                  class="text-right"
                  v-if="showMode === 'qty' || showMode === 'all'"
                >
                  {{ formatNumberRibuan(getItemTotalQty(item)) }}
                </td>

                <td
                  class="text-right"
                  v-if="showMode === 'values' || showMode === 'all'"
                >
                  {{ formatRupiahUtil(getItemTotalPrice(item)) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- realization by worksheet -->
    <v-dialog v-model="isDialogOpenRealizationByWorksheetId" max-width="1200px">
      <v-card class="rounded-xl">
        <v-btn
          icon
          variant="text"
          color="grey-darken-1"
          class="close-btn"
          @click="isDialogOpenRealizationByWorksheetId = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="px-6 py-4">
          <div class="d-flex justify-space-between align-center w-100">
            <!-- LEFT -->
            <div>
              <div class="text-subtitle-1 font-weight-bold mb-1">Realisasi</div>

              <v-simple-table dense class="elevation-1">
                <tbody>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Kertas Kerja</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.worksheet_budget_name || "-" }}</td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td style="width: 1%; white-space: nowrap">Account</td>
                    <td class="text-medium-emphasis pr-2" style="width: 1%">
                      :
                    </td>
                    <td>{{ selectedItem?.account || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Bagian</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.part || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Departement</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.departement_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Lokasi Kerja</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.dc_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Perusahaan</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.corporate_name || "-" }}</td>
                  </tr>

                  <tr>
                    <td style="white-space: nowrap">Tahun</td>
                    <td class="text-medium-emphasis pr-2">:</td>
                    <td>{{ selectedItem?.fiscal_year - 1 || "-" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-data-table
          dense
          fixed-header
          class="elevation-1 no-wrap-table"
          :headers="tableHeadersRealizationByWorksheetId"
          :items="listRealizationByWorksheetId"
          :loading="isLoading"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5, 10],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="text-center cursor-pointer">
                  {{ item.item_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.material_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.spesification || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ item.uom_name || "" }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ formatNumberRibuan(item.count_month_qty) || "" }}
                </td>

                <!-- JAN -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 1, 1)"
                >
                  {{ formatNumberRibuan(item.january_qty || 0) }}
                </td>

                <!-- FEB -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 2, 2)"
                >
                  {{ formatNumberRibuan(item.february_qty || 0) }}
                </td>

                <!-- MAR -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 3, 3)"
                >
                  {{ formatNumberRibuan(item.march_qty || 0) }}
                </td>

                <!-- APR -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 4, 4)"
                >
                  {{ formatNumberRibuan(item.april_qty || 0) }}
                </td>

                <!-- MAY -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 5, 5)"
                >
                  {{ formatNumberRibuan(item.may_qty || 0) }}
                </td>

                <!-- JUN -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 6, 6)"
                >
                  {{ formatNumberRibuan(item.june_qty || 0) }}
                </td>

                <!-- JUL -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 7, 7)"
                >
                  {{ formatNumberRibuan(item.july_qty || 0) }}
                </td>

                <!-- AUG -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 8, 8)"
                >
                  {{ formatNumberRibuan(item.august_qty || 0) }}
                </td>

                <!-- SEP -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 9, 9)"
                >
                  {{ formatNumberRibuan(item.september_qty || 0) }}
                </td>

                <!-- OCT -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 10, 10)"
                >
                  {{ formatNumberRibuan(item.october_qty || 0) }}
                </td>

                <!-- NOV -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 11, 11)"
                >
                  {{ formatNumberRibuan(item.november_qty || 0) }}
                </td>

                <!-- DEC -->
                <td
                  class="text-center cursor-pointer"
                  @click="openDialogRealizationSuccessByMonth(item, 12, 12)"
                >
                  {{ formatNumberRibuan(item.december_qty || 0) }}
                </td>

                <td class="text-center cursor-pointer">
                  {{ formatNumberRibuan(item.yearly_qty) || "" }}
                </td>
                <td class="text-center cursor-pointer">
                  {{ formatRupiahUtil(item.yearly_ending) || "" }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider></v-divider>

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- realization by month -->
    <v-dialog v-model="isDialogOpenRealizationByMonth" max-width="1200px">
      <v-card class="rounded-xl">
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <div>
            <div class="text-h6 font-weight-bold">
              Realisasi Kartu Buku Besar
            </div>
          </div>

          <div class="d-flex align-center ga-2">
            <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  @click="isDialogOpenRealizationByMonth = false"
                >
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-data-table
          dense
          fixed-header
          class="elevation-1"
          :headers="tableHeadersRealizationByMonth"
          :items="listRealizationSuccessByMonth"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5, 10],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td style="min-width: 180px">
                  {{ item.account || "-" }}
                </td>

                <td>
                  {{ item.transaksi_date || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.item_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.material_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.spesification || "-" }}
                </td>

                <td class="text-center">
                  {{ item.qty || 0 }}
                </td>

                <td>
                  {{ item.uom_name || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.dc_code || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.mst_corporate_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.supplier_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.departement_name || "-" }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.debit || 0) }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.credit || 0) }}
                </td>

                <td class="text-center sticky-excel">
                  <v-btn
                    v-if="item.object_excel"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogExcel(item.object_excel)"
                  >
                    <v-icon size="16">mdi-file-eye</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider />

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            variant="outlined"
            color="secondary"
            @click="isDialogOpenRealizationByMonth = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog excel referensi -->
    <v-dialog v-model="isDialogExcel" max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title class="text-h6 font-weight-bold">
          Realisasi Kartu Buku Besar (Excel)
        </v-card-title>

        <v-divider />

        <v-card-text v-if="selectedRealizationExcel">
          <v-row dense>
            <v-col cols="6">
              <strong>K2:</strong><br />
              {{ selectedRealizationExcel.k2 }}
            </v-col>

            <v-col cols="6">
              <strong>ACC:</strong><br />
              {{ selectedRealizationExcel.acc }}
            </v-col>

            <v-col cols="6">
              <strong>NO_ACCOUNT:</strong><br />
              {{ selectedRealizationExcel.no_account }}
            </v-col>

            <v-col cols="6">
              <strong>DATE:</strong><br />
              {{ selectedRealizationExcel.date }}
            </v-col>

            <v-col cols="6">
              <strong>DESCRIPTION:</strong><br />
              {{ selectedRealizationExcel.description }}
            </v-col>

            <v-col cols="6">
              <strong>DEBIT:</strong><br />
              {{ selectedRealizationExcel.debit }}
            </v-col>

            <v-col cols="6">
              <strong>CREDIT:</strong><br />
              {{ selectedRealizationExcel.credit }}
            </v-col>

            <!-- <v-col cols="6">
              <strong>ENDING:</strong><br />
              {{ selectedRealizationExcel.ending }}
            </v-col> -->
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isDialogComment" max-width="900">
      <v-card rounded="lg">
        <!-- Header -->
        <v-card-title class="d-flex align-center py-4">
          <v-icon class="mr-2">mdi-forum-outline</v-icon>
          {{ `Chat untuk item (${selectedChat.item_name})` }}

          <v-spacer />

          <v-chip size="small" color="primary" variant="tonal">
            {{ listChatDetail.length }} chat
          </v-chip>
        </v-card-title>

        <v-divider />

        <!-- Area Chat -->
        <v-card-text
          class="pa-4"
          style="height: 500px; overflow-y: auto; background: #f8fafc"
        >
          <div v-if="listChatDetail.length">
            <div
              v-for="history in listChatDetail"
              :key="history.id"
              class="mb-4"
            >
              <div
                class="d-flex"
                :class="
                  history.created_by === user.mst_employee_id
                    ? 'justify-end'
                    : 'justify-start'
                "
              >
                <div
                  class="d-flex align-end"
                  :class="
                    history.created_by === user.mst_employee_id
                      ? 'flex-row-reverse'
                      : ''
                  "
                  style="max-width: 75%"
                >
                  <!-- Avatar -->
                  <v-avatar
                    size="36"
                    color="primary"
                    :class="
                      history.created_by === user.mst_employee_id
                        ? 'ml-2'
                        : 'mr-2'
                    "
                  >
                    {{ history.created_by_name?.charAt(0)?.toUpperCase() }}
                  </v-avatar>

                  <!-- Bubble -->
                  <div>
                    <div
                      class="text-caption mb-1"
                      :class="
                        history.created_by === user.mst_employee_id
                          ? 'text-right'
                          : ''
                      "
                    >
                      <strong>
                        {{ history.created_by_name }}
                      </strong>
                      ·
                      {{ history.created_on }}
                    </div>

                    <v-sheet
                      rounded="xl"
                      class="pa-3"
                      :color="
                        history.created_by === user.mst_employee_id
                          ? 'white'
                          : 'white'
                      "
                      :class="
                        history.created_by === user.mst_employee_id ? '' : ''
                      "
                      style="border: 1px solid #e5e7eb; word-break: break-word"
                    >
                      {{ history.comments }}
                    </v-sheet>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-alert v-else type="info" variant="tonal">
            Belum ada chat.
          </v-alert>
        </v-card-text>

        <v-divider />

        <!-- Input Chat -->
        <div class="pa-4 bg-grey-lighten-5">
          <div class="d-flex align-end">
            <v-textarea
              v-model="selectedChat.comments"
              placeholder="Tulis chat..."
              variant="outlined"
              auto-grow
              rows="2"
              hide-details
              class="flex-grow-1"
              density="comfortable"
            />

            <v-btn
              color="primary"
              class="ml-3"
              size="large"
              icon
              @click="submitInsertDetailChat"
            >
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-actions class="justify-end">
          <v-btn
            variant="outlined"
            prepend-icon="mdi-close"
            @click="isDialogComment = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getCurrentYear, getCurrentYearRange } from "@/utils/date";
import { formatNumberRibuan, formatRupiahUtil } from "@/utils/formatter";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      currentYearRange: getCurrentYearRange(),
      yearOptions: Array.from({ length: 6 }, (_, i) => currentYear + i),
      months: [
        { id: 1, key: "january", label: "Jan" },
        { id: 2, key: "february", label: "Feb" },
        { id: 3, key: "march", label: "Mar" },
        { id: 4, key: "april", label: "Apr" },
        { id: 5, key: "may", label: "May" },
        { id: 6, key: "june", label: "Jun" },
        { id: 7, key: "july", label: "Jul" },
        { id: 8, key: "august", label: "Aug" },
        { id: 9, key: "september", label: "Sep" },
        { id: 10, key: "october", label: "Oct" },
        { id: 11, key: "november", label: "Nov" },
        { id: 12, key: "december", label: "Dec" },
      ],
      mode: null,
      modeBulk: null,
      dialogTitle: "",
      dialogTitleBulk: "",
      tab: 1,
      tabItems: ["Persetujuan"],
      approvalsList: [],
      approvalHistoryList: [],
      listDetail: [],
      listChatDetail: [],
      isLoading: false,
      isDialogDetail: false,
      isDialogOpen: false,
      isDialogOpenBulk: false,
      isDialogOpenApprovalHistory: false,
      isDialogOpenApproval: false,
      isDialogOpenPic: false,
      isDialogCreateDetail: false,
      isDialogDeleteDetail: false,
      isDialogOpenRealizationByWorksheetId: false,
      isDialogOpenRealizationByMonth: false,
      isDialogExcel: false,
      isDialogComment: false,
      selectedItem: null,
      selectedItemDetail: null,
      selectedItemRealizationSuccess: null,
      selectedRealizationExcel: {},
      selectedChat: {
        comments: null,
        budget_id: null,
        item_id: null,
        item_name: null,
        material_id: null,
        spesification: null,
        fiscal_year: null,
      },
      selected: [],
      dialogMode: "approve",
      isFormValid: false,
      isFormValidBulk: false,
      isCommentValid: false,
      approvalFormData: {
        comments: "",
        status: "",
      },

      approvalFormDataBulk: {
        comments: "",
        status: "",
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      tableHeaders: [
        {
          text: "",
          value: "select",
          sortable: false,
          width: 60,
          align: "center",
        },

        { text: "No Budget", align: "center", value: "transaction_number" },
        {
          text: "Kertas Kerja Budget",
          align: "center",
          value: "worksheet_budget_name",
        },
        {
          text: "Departement",
          align: "center",
          value: "departement_name",
        },
        {
          text: "Lokasi Kerja",
          align: "center",
          value: "dc_code",
        },

        {
          text: "Perusahaan",
          align: "center",
          value: "corporate_name",
        },

        {
          text: "Riwayat Persetujuan",

          align: "center",
          value: "history_approval",
        },
        {
          text: "Status",
          align: "center",
          value: "last_status",
          width: "100px",
        },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        {
          text: "Aksi",
          align: "center",
          value: "actions",
          width: "150px",
        },
      ],
      tableHeadersDetail: [
        {
          text: "Realisasi",
          align: "center",
          value: "realization",
          width: "80px",
        },
        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "180px",
        },

        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "180px",
        },

        {
          text: "Spesifikasi",
          align: "center",
          value: "spesification",
          width: "180px",
        },

        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          width: "120px",
        },

        {
          text: "Chat",
          align: "center",
          value: "comment",
          width: "120px",
        },

        // QTY
        ...[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ].map((month) => ({
          text: `${month} Qty`,
          value: `${month.toLowerCase()}_qty`,
          width: "100px",
          type: "qty",
        })),

        // VALUE
        ...[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ].map((month) => ({
          text: `${month} Values`,
          value: `${month.toLowerCase()}_total_price`,
          width: "130px",
          type: "values",
        })),

        {
          text: "Total Qty",
          value: "total_qty",
          align: "end",
          type: "qty",
        },

        {
          text: "Total Values",
          value: "total_values",
          align: "end",
          type: "values",
        },
      ],
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Dibuat", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],

      tableHeadersRealizationByWorksheetId: [
        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "130px",
        },

        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "130px",
        },

        { text: "Spesifikasi", align: "center", value: "spesification" },

        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          width: "100px",
        },

        {
          text: "Frekuensi",
          align: "center",
          value: "count_month_qty",
          width: "120px",
        },

        // MONTHLY QTY
        {
          text: "Jan",
          align: "center",
          value: "january_qty",
          width: "90px",
        },
        {
          text: "Feb",
          align: "center",
          value: "february_qty",
          width: "90px",
        },
        {
          text: "Mar",
          align: "center",
          value: "march_qty",
          width: "90px",
        },
        {
          text: "Apr",
          align: "center",
          value: "april_qty",
          width: "90px",
        },
        {
          text: "May",
          align: "center",
          value: "may_qty",
          width: "90px",
        },
        {
          text: "Jun",
          align: "center",
          value: "june_qty",
          width: "90px",
        },
        {
          text: "Jul",
          align: "center",
          value: "july_qty",
          width: "90px",
        },
        {
          text: "Aug",
          align: "center",
          value: "august_qty",
          width: "90px",
        },
        {
          text: "Sep",
          align: "center",
          value: "september_qty",
          width: "90px",
        },
        {
          text: "Oct",
          align: "center",
          value: "october_qty",
          width: "90px",
        },
        {
          text: "Nov",
          align: "center",
          value: "november_qty",
          width: "90px",
        },
        {
          text: "Dec",
          align: "center",
          value: "december_qty",
          width: "90px",
        },

        {
          text: "Total Qty",
          align: "center",
          value: "yearly_qty",
          width: "120px",
        },
        {
          text: "Total Harga",
          align: "center",
          value: "yearly_ending",
          width: "120px",
        },
      ],
      tableHeadersRealizationByMonth: [
        { text: "Account", align: "center", value: "account" },
        { text: "Tanggal", align: "center", value: "transaksi_date" },
        { text: "Item", align: "center", value: "item_name" },
        { text: "Material", align: "center", value: "material_name" },
        { text: "Spesifikasi", align: "center", value: "spesification" },
        { text: "qty", align: "center", value: "qty", width: "100px" },
        { text: "Satuan", align: "center", value: "uom_name" },
        { text: "Lokasi Kerja", align: "center", value: "dc_code" },
        { text: "Perusahaan", align: "center", value: "corporate_name" },
        { text: "Supplier", align: "center", value: "supplier_name" },
        { text: "Departemen", align: "center", value: "departement_name" },
        { text: "Debit", align: "center", value: "debit" },
        { text: "Kredit", align: "center", value: "credit", width: "100px" },
        {
          text: "",
          align: "center",
          value: "object_excel",
          width: "60px",
          class: "sticky-excel",
        },
      ],

      totalApprovals: 0,
      note: "",
      budgetId: null,
      is_unread: 1,
      stepId: null,
      total_unread: 0,
      listWorksheet: [],
      listRealizationByWorksheetId: [],
      listRealizationSuccessByMonth: [],
      showMode: "qty",
      searchDetail: "",
    };
  },
  methods: {
    formatNumberRibuan,
    formatRupiahUtil,
    async openDialogExcel(item) {
      this.selectedRealizationExcel = item;
      this.isDialogExcel = true;
    },

    async openDialogRealizationByWorksheetId(item) {
      // console.log(item);
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;

      const params = {
        lastStatus: "success",
        worksheet: item.worksheet_budget_id,
        departementId: item.departement_id,
        siteId: item.site_id,
        corporateId: item.corporate_id,
        year: item.fiscal_year,
        itemId: item.item_id,
        materialId: item.material_id,
        spesification: item.spesification,
        uomId: item.uom_id,
      };

      await api
        .get("/realization/forbudget-byworksheetid", { params })
        .then(({ data }) => {
          this.listRealizationByWorksheetId = data.data;
        })
        .catch((error) => {
          console.error("Error fetching approve:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
      this.isDialogOpenRealizationByWorksheetId = true;
    },

    async openDialogRealizationSuccessByMonth(item, monthStart, monthEnd) {
      this.listRealizationSuccessByMonth = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      const params = {
        worksheetId: item.worksheet_budget_id,
        itemId: item.item_id,
        materialId: item.material_id,
        spesification: item.spesification,
        uomId: item.uom_id,
        fiscalYear: item.fiscal_year,
        monthStart: monthStart,
        monthEnd: monthEnd,
        departementId: item.departement_id,
        siteId: item.site_id,
        corporateId: item.corporate_id,
        part: item.part,
      };

      await api
        .get("/realization/forbudget-bymonth", {
          params,
        })
        .then(({ data }) => {
          // console.log(data);
          this.listRealizationSuccessByMonth = data.data || [];
          this.isDialogOpenRealizationByMonth = true;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async openDialogDetail(item) {
      // Tampilkan loading
      this.selectedItem = item;
      // console.log(this.selectedItem);
      this.listDetail = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      await api
        .get(`budget-detail/by-budget-id/${item.budget_id}`)
        .then(({ data }) => {
          // console.log(data);
          this.listDetail = data.data || [];

          // console.log(this.listDetail);

          // console.log(this.listDetail);
          this.isDialogDetail = true;
          this.submitRead(item.budget_id);
        })
        .catch((error) => {
          console.error("Error fetching approve:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    openApprovalDialog(mode, params = null) {
      // console.log(params);
      // return;
      this.mode = mode;
      this.dialogTitle =
        mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase();
      this.approvalFormData = { ...params };
      this.isDialogOpen = true;
    },

    openApprovalDialogBulk(mode) {
      this.modeBulk = mode;
      this.dialogTitleBulk =
        mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase();
      this.isDialogOpenBulk = true;
    },

    openApprovalHistory(budget_id) {
      api
        .get(`/approvals/by-budget-id/${budget_id}`)
        .then(({ data }) => {
          this.approvalHistoryList = data.data;
          this.isDialogOpenApprovalHistory = true;
        })
        .catch((error) => {
          this.approvalHistoryList = [];
          this.isDialogOpenApprovalHistory = true;
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async openDialogChat(item) {
      this.selectedChat.budget_id = item.budget_id;
      this.selectedChat.item_id = item.item_id;
      this.selectedChat.item_name = item.item_name;
      this.selectedChat.material_id = item.material_id;
      this.selectedChat.spesification = item.spesification;
      this.selectedChat.fiscal_year = item.fiscal_year;

      const params = {
        budget_id: item.budget_id,
        item_id: item.item_id,
        material_id: item.material_id,
        spesification: item.spesification,
        fiscal_year: item.fiscal_year,
      };
      // console.log(this.selectedItem);
      this.listChatDetail = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      await api
        .get(`chats`, { params })
        .then(({ data }) => {
          // console.log(data.data);
          this.listChatDetail = data.data || [];

          // console.log(this.listDetail);

          // console.log(this.listDetail);
          this.isDialogComment = true;
        })
        .catch((error) => {
          console.error("Error fetching approve:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchApproval() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await api
        .get("/approvals", { params })
        .then(({ data }) => {
          // console.log(data);
          this.approvalsList = data.data.data;
          this.totalApprovals = data.data.total;
          this.total_unread = data.data.total_unread;
          store.commit("setTotalApprovals", data.data.total_unread);
        })
        .catch((error) => {
          console.error("Error fetching approve:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchDetail(budgetId) {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: 1,
        limit: -1,
        lastStatus: "",
        worksheet: query.worksheet || this.pagination.worksheet,
        budgetId: budgetId,
      };

      await api
        .get("/budget-detail", { params })
        .then(({ data }) => {
          // console.log(data);
          this.listDetail = data.data.data;

          // console.log(this.listDetail);

          // console.log(this.listDetail);
          this.isDialogDetail = true;
          this.submitRead(budgetId);
        })
        .catch((error) => {
          console.error("Error fetching approve:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchWorksheet() {
      api
        .get("/wb")
        .then(({ data }) => {
          this.listWorksheet = data.data.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    fetchParameter() {
      api
        .get("/parameters")
        .then(({ data }) => {
          this.listParameter = data.data.data;

          // ambil kenaikan harga
          this.KENAIKAN_HARGA =
            this.listParameter.find(
              (e) =>
                e.fiscal_year == getCurrentYear() &&
                e.name === "KENAIKAN_HARGA",
            )?.value || 1;

          // hitung semua item saat pertama load
          // this.listRealizationSuccess = this.listRealizationSuccess.map(
          //   (item) => ({
          //     ...item,
          //     price: item.price * this.KENAIKAN_HARGA,
          //   }),
          // );

          // console.log(this.KENAIKAN_HARGA);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    submit() {
      store.dispatch("showLoading");
      this.approvalFormData.status = this.mode;

      // Pastikan hanya id dari role yang dikirimkan
      const payload = { ...this.approvalFormData };
      payload.is_quick_win = this.isQuickWinOptionsSelected;

      // console.log(payload);

      api
        .post("/approvals", payload)
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Menampilkan pesan dengan status "success" (hijau)
          this.fetchApproval(); // Fungsi untuk mengambil data karyawan terbaru
          this.isDialogOpen = false;

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save approve!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitBulk() {
      store.dispatch("showLoading");
      this.approvalFormDataBulk.status = this.modeBulk;

      // Pastikan hanya id dari role yang dikirimkan
      const payload = { ...this.approvalFormDataBulk };
      payload.list_budget = this.selected;

      // console.log(payload);

      api
        .post("/approvals/bulk", payload)
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Menampilkan pesan dengan status "success" (hijau)
          this.fetchApproval(); // Fungsi untuk mengambil data karyawan terbaru
          this.isDialogOpenBulk = false;

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save approve!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitRead(budgetId) {
      const payload = {
        budget_id: budgetId,
        is_unread: 0,
      };

      // console.log(payload);
      api
        .post("/approvals/update/read", payload)
        .then(() => {
          // const message = response.data.message;
          this.fetchApproval();
          // store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to read tittle!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitInsertDetailChat() {
      store.dispatch("showLoading");
      const payload = {
        budget_id: this.selectedItem.budget_id,
        step_id: this.selectedItem.step_id,
        comments: this.selectedChat.comments,
        item_id: this.selectedChat.item_id,
        material_id: this.selectedChat.material_id,
        spesification: this.selectedChat.spesification,
        fiscal_year: this.selectedChat.fiscal_year,
      };

      api
        .post("/chats", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", {
            message: message,
            isSuccess: true,
          });
          this.openDialogChat(this.selectedChat);
          this.selectedChat.comments = null;
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },

    formatRupiah(value) {
      if (!value) return "Rp 0";
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    getStatusColor(status) {
      if (!status) return "default";

      const s = status.toLowerCase();

      if (s.includes("approved")) return "success";

      switch (s) {
        case "pending":
          return "warning";
        case "success":
          return "success";
        case "cancel":
          return "grey";
        case "rejected":
          return "error";
        case "need to analysis":
          return "orange";
        default:
          return "default";
      }
    },
    getItemTotalQty(item) {
      return this.months.reduce((total, month) => {
        // console.log(Number(item[`${month.key}_qty`]));
        return total + Number(item[`${month.key}_qty`] || 0);
      }, 0);
    },
    getItemTotalPrice(item) {
      return this.months.reduce((total, month) => {
        return total + Number(item[`${month.key}_total_price`] || 0);
      }, 0);
    },
  },
  watch: {
    pagination: {
      handler: "fetchApproval",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Persetujuan");
    this.fetchParameter();
    this.fetchApproval();
    this.updatePagination(this.$route.query);
  },
  computed: {
    isQty() {
      return this.showMode === "qty" || this.showMode === "all";
    },

    isValues() {
      return this.showMode === "values" || this.showMode === "all";
    },
    tableHeadersDetailFiltered() {
      return this.tableHeadersDetail.filter((header) => {
        if (!header.type) return true;

        if (this.showMode === "qty") {
          return header.type === "qty";
        }

        if (this.showMode === "values") {
          return header.type === "values";
        }

        if (this.showMode === "all") {
          return ["qty", "values"].includes(header.type);
        }

        return true;
      });
    },
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.approvalFormData.benefit,
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.approvalFormData.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },

    filteredListDetail() {
      const keyword = (this.searchDetail || "").toLowerCase().trim();

      if (!keyword) return this.listDetail;

      return this.listDetail.filter(
        (item) =>
          item.item_name?.toLowerCase().includes(keyword) ||
          item.material_name?.toLowerCase().includes(keyword) ||
          item.spesification?.toLowerCase().includes(keyword) ||
          item.uom_name?.toLowerCase().includes(keyword),
      );
    },
  },
};
</script>

<style scoped>
.custom-autocomplete .v-field__input {
  font-size: 8px !important;
}

.custom-autocomplete .v-list-item-title {
  font-size: 8px !important;
}

.v-data-table thead th {
  text-align: center;
  vertical-align: middle;
}

.custom-table th,
.custom-table td {
  white-space: nowrap;
}

.table-wrapper table th,
.table-wrapper table td {
  white-space: nowrap;
}

.no-wrap-table td,
.no-wrap-table th {
  white-space: nowrap;
}

.sticky-excel {
  position: sticky;
  right: 0px;
  background: white;
  z-index: 2;
}

.sticky-action {
  position: sticky;
  right: 0;
  background: white;
  z-index: 3;
}

.month-input {
  width: 75px;
}

.month-input :deep(.v-field) {
  min-height: 34px !important;
  border-radius: 8px !important;
}

.month-input :deep(.v-field__input) {
  min-height: 34px !important;
  padding: 0 8px !important;
}

.month-input :deep(input) {
  text-align: center;
  font-size: 13px;
  font-weight: 500;
}

.budget-table {
  font-size: 13px;
}

.budget-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  white-space: nowrap;
}

.month-input {
  min-width: 90px;
}

.month-input :deep(input) {
  text-align: center;
}

.sticky-realization {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white;
}

.sticky-action {
  position: sticky;
  right: 0;
  z-index: 2;
  background: white;
}

.v-card-title {
  min-height: 90px;
}

.dialog-header {
  position: relative;
  background: #fff;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.text-lightgray {
  background-color: #ffffff; /* abu-abu terang */
  cursor: pointer;
  padding: 5px;
}

.text-unread {
  background-color: #bcf8d4; /* abu-abu terang */
  cursor: pointer;
  padding: 5px;
}
.status-box {
  margin-top: 30px;
  padding: 2px 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 0.65rem;
}
.total-unread {
  position: absolute;
  left: 70px;
  transform: translatey(0px);
}

.new-item-row {
  background-color: #b3e2bd !important;
  border-left: 4px solid #2e7d32;
}

.new-item-row:hover {
  background-color: #63c376 !important;
}
</style>
